import {
  GetPlannedBreaksDocument,
  GetPlannedBreaksQuery,
  GetPlannedBreaksQueryVariables,
  PlannedBreakFragment,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import PlannedBreaksCollection from 'modules/time_planning/store/internal/collections/plannedBreaks'

export type PlannedBreaks =
  GetPlannedBreaksQuery['timePlanning']['plannedBreaksConnection']['nodes']

interface Props {
  variables: GetPlannedBreaksQueryVariables
  skip?: boolean
}

export const useGetPlannedBreaks = ({ variables, skip = false }: Props) => {
  const { loading, data, refetch } = useQuery(GetPlannedBreaksDocument, { variables, skip })
  const plannedBreaks: PlannedBreakFragment[] = data
    ? data.timePlanning.plannedBreaksConnection.nodes
    : []
  const plannedBreaksCollection = PlannedBreaksCollection.buildFromRequest(plannedBreaks)

  return {
    refetch,
    loading,
    plannedBreaks,
    plannedBreaksCollection,
  }
}
